<template>
	<div ref="chart" :id="uuid" class="pieEchart"></div>
</template>

<script>
import { getUuid } from '@/utils/api';
const eCharts = require('echarts');

export default {
	data() {
		return {
			chart: null,
			uuid: 'bar-' + getUuid(5),
			pieColor: ['#FF5260', '#FF7357', '#FFA05C', '#FFCA61', '#FFE666', '#6284EB', '#6BA3F2', '#7AD3FF', '', '']
		};
	},
	props: {
		orgData: {
			type: Object,
			default: () => {}
		}
	},
	methods: {
		initEchart() {
			if (!this.$refs.chart) return;
			if (this.chart) {
				this.chart.clear();
				this.chart.dispose();
				this.chart = null;
			}

			let chartDom = document.querySelector('#' + this.uuid);
			this.chart = eCharts.init(chartDom);
			let option;

			option = {
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(255,255,255,0.9)',
					formatter: item => {
						return `<div class="pie-tooltip">
							<i style="background: ${item.color}" class="tooltip-circle"></i>${item.name}
							<div><em>占比</em><span>${((item.value / this.orgData?.totalHoldings) * 100).toFixed(2)}%</span></div>
						</div>`;
					}
				},
				color: this.pieColor,
				series: [
					{
						name: 'Access From',
						type: 'pie',
						radius: ['45%', '72%'],
						avoidLabelOverlap: false,
						label: {
							normal: {
								show: true,
								position: 'center',
								textStyle: {
									fontSize: 12,
									color: '#333'
								},
								formatter: item => {
									if (item.dataIndex == 0) {
										return item.name;
									} else {
										return '';
									}
								}
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: 12,
									color: '#333'
								},
								formatter: item => {
									return item.name;
								}
							}
						},
						labelLine: {
							show: false
						},
						data: this.pieData
					}
				]
			};
			this.chart.on('mouseover', params => {
				option.series[0].label.normal.show = false;
				this.chart.setOption(option);
			});
			this.chart.on('mouseout', params => {
				option.series[0].label.normal.show = true;
				this.chart.setOption(option);
			});
			option && this.chart.setOption(option);
		}
	},
	watch: {
		orgData: {
			handler(newVal, oldVal) {
				this.$nextTick(() => {
					newVal && this.initEchart();
				});
			},
			deep: true,
			immediate: true
		}
	},
	computed: {
		pieData() {
			return (this.orgData.data || []).map(item => {
				return { name: item.institutionType, value: item.holdings };
			});
		}
	}
};
</script>

<style lang="less">
.pieEchart {
	width: 100%;
	height: 1.8rem;
}
.pie-tooltip {
	color: #18263c;
	& > div {
		margin-top: 2px;
		margin-left: 8px;
		color: #646a73;

		& > em {
			font-style: inherit;
			padding-right: 10px;
		}

		& > span {
			font-style: inherit;
			float: right;
		}
	}
}
.tooltip-circle {
	width: 4px;
	height: 4px;
	margin-right: 4px;
	border-radius: 50%;
	display: inline-block;
	background: #8e92cc;
	vertical-align: middle;
	transform: translateY(-2px);
}
</style>
